import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { dashboard as dashboardRoutes, auth as authRoutes, TandC as termsAndCondsRoutes} from "./index";

import DashboardLayout from "../layouts/Dashboard";
import AuthLayout from "../layouts/Auth";
import TandCLayout from "../layouts/TermsAndConds";
import Page404 from "../pages/auth/Page404";
import UserFlowGuard from "../components/UserFlowGuard";

const childRoutes = (Layout, routes) =>
  routes.map(({ children, path, component: Component }, index) =>
    children ? (
      // Route item with children
      children.map(({ path, component: Component }, index) => (
        <Route
          key={index}
          path={path}
          exact
          render={props => (
            <Layout>
              <Component {...props} />
            </Layout>
          )}
        />
      ))
    ) : (
      // Route item without children
      <Route
        key={index}
        path={path}
        exact
        render={props => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    )
  );

const Routes = () => (
    <UserFlowGuard>
      <Switch>
        {childRoutes(DashboardLayout, dashboardRoutes)}
        {childRoutes(AuthLayout, authRoutes)}
        {childRoutes(TandCLayout, termsAndCondsRoutes)}
        <Route
          render={() => (
            <AuthLayout>
              <Page404 />
            </AuthLayout>
          )}
        />
      </Switch>
    </UserFlowGuard>
);

export default Routes;
